var initialState = {
    draftBeforeChange: null
};

export default (state, action) => {
    state = state || initialState;
    switch (action.type) {
        case 'SET_DRAFT_BEFORE_CHANGE':
            return { ...state, draftBeforeChange: action.payload };
        default:
            return state;
    }
};
